import { render, staticRenderFns } from "./DataImportManager.vue?vue&type=template&id=0dbbb3c8&scoped=true"
import script from "./DataImportManager.vue?vue&type=script&lang=js"
export * from "./DataImportManager.vue?vue&type=script&lang=js"
import style0 from "./DataImportManager.vue?vue&type=style&index=0&id=0dbbb3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbbb3c8",
  null
  
)

export default component.exports